'use client'
import { useEffect, useState } from 'react'
import ErrorBoundary from '@error-boundary'

// import dynamic from 'next/dynamic'
import { useUi } from '@contexts/ui.context'

export const RaNotificationWrapper = () => {
  const { modal, toaster, lightbox } = useUi()
  const [loadedComponents, setLoadedComponents] = useState({
    modal: false,
    toaster: false,
    lightbox: false,
  })

  // Lazy load components only when first needed
  const [RaModal, setRaModal] = useState(null)
  const [RaToaster, setRaToaster] = useState(null)
  const [RaLightbox, setRaLightbox] = useState(null)

  useEffect(() => {
    if (modal.isOpen && !loadedComponents.modal) {
      const loadModal = async () => {
        const { RaModal: ModalComponent } = await import('@components/features/RaModal/RaModal')
        setRaModal(() => ModalComponent)
        setLoadedComponents(prev => ({ ...prev, modal: true }))
      }
      loadModal()
    }
  }, [modal.isOpen, loadedComponents.modal])

  useEffect(() => {
    if (toaster.isOpen && !loadedComponents.toaster) {
      const loadToaster = async () => {
        const { RaToaster: ToasterComponent } =
          await import('@components/features/RaToaster/RaToaster')
        setRaToaster(() => ToasterComponent)
        setLoadedComponents(prev => ({ ...prev, toaster: true }))
      }
      loadToaster()
    }
  }, [toaster.isOpen, loadedComponents.toaster])

  useEffect(() => {
    if (lightbox.isOpen && !loadedComponents.lightbox) {
      const loadLightbox = async () => {
        const { RaLightbox: LightboxComponent } =
          await import('@components/features/RaLightbox/RaLightbox')
        setRaLightbox(() => LightboxComponent)
        setLoadedComponents(prev => ({ ...prev, lightbox: true }))
      }
      loadLightbox()
    }
  }, [lightbox.isOpen, loadedComponents.lightbox])

  return (
    <ErrorBoundary>
      {RaModal && <RaModal />}
      {RaToaster && <RaToaster />}
      {RaLightbox && <RaLightbox />}
    </ErrorBoundary>
  )
}
